import React, { Component } from "react"
import marked from "marked"
import { Button } from "react-bootstrap"
import post1 from "./blog/what-is-crypto-portfolio-tracker.md"
import post2 from "./blog/crypto-trading-faq.md"

import { LinkContainer } from "react-router-bootstrap"

export default class Blog extends Component {
	constructor(props) {
		super(props)
		this.state = {
			html: null,
		}
	}

	componentDidMount() {
		this.loadData()
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.match.params !== prevProps.match.params) {
			this.loadData()
		}
	}

	async loadData() {
		const { id } = this.props.match.params
		if (id === undefined) {
			return this.loadIndexData()
		}
		let res = null
		if (id === "what-is-crypto-portfolio-tracker") {
			res = await window.fetch(post1)
		} else if (id === "crypto-trading-faq") {
			res = await window.fetch(post2)
		}
		const text = await res.text()
		const html = marked(text, { sanitize: true })
		this.setState({
			html: {
				__html: html,
			},
		})
	}

	async loadIndexData() {
		const res = await Promise.all([window.fetch(post1), window.fetch(post2)])
		const text1 = await res[0].text()
		const text2 = await res[1].text()
		const html = marked(text2 + "\n" + text1, { sanitize: true })
		this.setState({
			html: {
				__html: html,
			},
		})
	}

	render() {
		if (this.state.html === null) {
			return null
		}
		return (
			<div className="blog">
				<div dangerouslySetInnerHTML={this.state.html} />
				<LinkContainer to="/" exact>
					<Button bsStyle="primary">Back to Crypto Portfolio Tracker</Button>
				</LinkContainer>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Blog.js